import { formatToCurrency } from "shared/utils";
import { BillingActivity } from "types/application";
import { getDisplayName } from "../utils";

export const CaliforniaRows = ({
  billingActivities
}: {
  billingActivities: BillingActivity[];
}) =>
  billingActivities
    .filter(
      (item) =>
        item.amount.cents !== 0 &&
        item.category !== "applicant_application_fee" &&
        item.category !== "refund"
    )
    .map((item, index) => {
      // Calculate quantity for items with the same name (description)
      const quantity = billingActivities.reduce((count, activity) => {
        return activity.description === item.description ? count + 1 : count;
      }, 0);

      const displayName = getDisplayName(item.category, item.description);

      return (
        <tr
          key={`${item.id}-${index}`}
          className="text-xxs text-content-1000 font-medium"
        >
          <td className="py-1 px-2">{displayName}</td>
          <td className="text-right">{quantity}</td>
          <td className="text-right">
            {formatToCurrency({
              cents: Math.abs(item.amount.cents),
              currency: item.amount.currency
            })}
          </td>
          <td className="text-right">
            {formatToCurrency({
              cents: Math.abs(item.amount.cents),
              currency: item.amount.currency
            })}
          </td>
        </tr>
      );
    });
